import { Tabs } from "antd";
import styles from './CleanerDetails.module.css';
import { useState } from "react";
import Profile from "./Profile";
import WorkSchedule from "./WorkSchedule";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { roles } from "../../../config/roles";
import CleanersTaskSummaryTab from "../CleanersTaskSummary/CleanersTaskSummaryTab";

const CleanerDetails = () => {
  const { width, height } = useWindowDimensions();
  const [Active, setActive] = useState();
  const [search, setsearch] = useState();
  const { t } = useTranslation();
  const location = useLocation();
  const role = localStorage.getItem('role')

  console.log('location', location)
  const items = [
    {
      key: "1",
      label: `${t("Profile")}`,
      children: <Profile data={location} />,
    },
    location.pathname != '/Cleaners/NewCleaners/Profile' ? {
      key: "2",
      label: `${role == roles.customer ? t("Task Summary") : t("Work Schedule")}`,
      children: role == roles.customer ? <CleanersTaskSummaryTab data={location} /> : <WorkSchedule data={location} />,
    } : {},
  ];

  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t("Cleaners")}</h1>
      </div>
      <Tabs
        className="tab_content_styling"
        size="large"
        defaultActiveKey="1"
        items={items}
        tabBarGutter={width > 570 ? 50 : 5}
        // centered
        onChange={onChange}
        tabBarStyle={
          width > 570
            ? {
              color: "white",
              fontWeight: "bold",
              width: "100%",
              margin: "0px 10px",
            }
            : {
              color: "white",
              fontSize: "8px",
            }
        }
      />
    </div>
  );
};
export default CleanerDetails;
